import { render, staticRenderFns } from "./TariffSettingsTooltip.vue?vue&type=template&id=45a81ccf&"
import script from "./TariffSettingsTooltip.vue?vue&type=script&lang=ts&"
export * from "./TariffSettingsTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./TariffSettingsTooltip.vue?vue&type=style&index=0&id=45a81ccf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports